import { FC, ReactNode } from 'react';

import { ButtonProps as MuiButtonProps } from '@mui/material';
import { Button as MuiButton } from 'ui/Button';

import { SxProps } from '@mui/material';
import { styles } from './styles';

export interface ButtonProps extends MuiButtonProps {
  variantType?:
    | 'primary'
    | 'outlined'
    | 'alert'
    | 'access'
    | 'mult'
    | 'alertFilled'
    | 'text';

  children?: ReactNode;
}

export const Button: FC<ButtonProps> = ({
  variantType = 'primary',
  children,
  ...rest
}) => {
  const buttonStyle = (variantType: string): SxProps => {
    return styles[variantType];
  };

  return (
    <MuiButton sx={buttonStyle(variantType)} {...rest} disableRipple>
      {children}
    </MuiButton>
  );
};
